import { StatusBar } from 'expo-status-bar';
import React, { useContext, useEffect, useState, ErrorInfo, ReactNode } from 'react';
import { StyleSheet, Text, View, Image, TextInput, Button, TouchableOpacity, ScrollView } from 'react-native';
import { withSafeAreaInsets } from 'react-native-safe-area-context';
import { AuthContext } from '../contexts/Auth';
import { useNavigate } from 'react-router-dom';
import { LinearGradient } from 'expo-linear-gradient';
import { Box, HStack, Spinner } from 'native-base';
import { Consts } from '../constants/Consts';
import { flexbox } from 'native-base/lib/typescript/theme/styled-system';
import { useThemeColors, useThemeImages, useThemedComponents, useThemedAjusts } from '../components/Themed';
import { ColorNames, ImageNames, ThemedComponentType, ThemedAjustType } from '../types';
import { placeholderCSS } from 'react-select/dist/declarations/src/components/Placeholder';
import AntDesign from '@expo/vector-icons/AntDesign';

export default function App() {
    const Colors: ColorNames = useThemeColors();
    const Images: ImageNames = useThemeImages();
    const ThemedComponent: ThemedComponentType = useThemedComponents();
    const Ajusts: ThemedAjustType = useThemedAjusts();

    const [userId, setUserId] = useState('');
    const [loading, setLoading] = useState(false);
    const { isAuth, login, loginErrorMessage } = useContext(AuthContext);
    const navigate = useNavigate();

    //クエリパラメータログインチェック
    const url = new URL(window.location.href);
    const id_value = url.searchParams.get('id');
    React.useEffect(() => {
        if (isAuth) {
            setLoading(false);
            navigate('/posts');
        }
    }, [isAuth]);

    React.useEffect(() => {
        if (id_value) {
            login(id_value);
        }
    }, [id_value]);

    const onPressLogin = () => {
        if (!loading) {
            login(userId);
            setLoading(true);
        }
    };

    React.useEffect(() => {
        if (loginErrorMessage) {
            setLoading(false);
        }
    }, [loginErrorMessage]);

    const styles = StyleSheet.create({
        scroll: {
            backgroundColor: Colors.white,
            paddingRight: 20,
            paddingLeft: 20
        },
        container: {
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 52,
            marginBottom: 52
        },
        image: {
            marginBottom: 52,
            width: '275px',
            height: '96px'
        },
        loginTitleBox: {
            width: Ajusts.loginTitleBoxSize,
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: Colors.lightGray,
            borderColor: Colors.mediumGray,
            borderWidth: 1,
            borderRightWidth: 0,
            borderBottomLeftRadius: 50,
            borderTopLeftRadius: 50
        },
        loginTitle: {
            fontSize: 12,
            fontWeight: '600'
        },
        loginTextBox: {
            height: '100%',
            width: Ajusts.loginTextBoxSize,
            justifyContent: 'center',
            borderWidth: 1,
            borderLeftWidth: 0,
            borderColor: Colors.mediumGray,
            borderBottomRightRadius: 50,
            borderTopRightRadius: 50
        },
        loginTextInput: {
            height: '100%',
            padding: 10,
            borderBottomRightRadius: 50,
            borderTopRightRadius: 50,
            fontSize: Ajusts.PlaceholderFontSize
        },
        loginButtonText: {
            color: Colors.white,
            fontWeight: 'bold'
        },
        loginButton: {
            maxWidth: '335px',
            width: '100%',
            borderRadius: 50,
            height: 50,
            alignItems: 'center',
            justifyContent: 'center'
        },
        errorText: {
            color: Colors.error,
            marginTop: 10
        },
        applicationTextBox: {
            paddingTop: '20px'
        },
        youtube: {
            marginTop: '10px',
            display: Ajusts.Display
        },
        applicationText: {
            textAlign: 'center',
            fontSize: 18,
            fontWeight: '800'
        },
        titleTxt: {
            fontWeight: 'bold',
            color: Colors.primary,
            fontSize: 20,
            paddingTop: '20px',
            textAlign: 'center'
        },
        titlePeriod: {
            fontSize: Ajusts.LoginPeriodFontSize,
            paddingTop: '20px'
        },
        titleNoticeBox: {
            paddingTop: '16px',
            paddingBottom: '16px',
            paddingLeft: '12px',
            paddingRight: '12px',
            border: '1px solid red',
            marginBottom: '20px'
        },
        titleNotice: {
            color: 'red',
            fontWeight: 'bold',
            fontSize: 16,
            textIndent: '-0.5em',
            marginBottom: '8px'
        },
        txtNotice: {
            color: 'red',
            fontWeight: 'bold',
            fontSize: 14
        }
    });

    return (
        <ScrollView contentContainerStyle={{ flexGrow: 1, justifyContent: 'center' }} style={styles.scroll}>
            <View style={styles.container}>
                <ThemedComponent.LoginImage marginBottom={Ajusts.HeaderImgMarginBottom} />
                {/* <StatusBar style="auto" /> */}

                {/* 年1回のログインパスワード変更作業案内の表示 */}
                {/* {Ajusts.LoginNotice && (
                    <Box style={styles.titleNoticeBox}>
                        <Text style={styles.titleNotice}>{Ajusts.LoginNoticeTitle}</Text>
                        <Text style={styles.txtNotice}>{Ajusts.LoginNotice}</Text>
                    </Box>
                )} */}

                <HStack flexDirection="row" marginBottom={15} maxWidth="335px" width="100%" height="46px">
                    <Box style={styles.loginTitleBox}>
                        <Text style={styles.loginTitle}>{Ajusts.LoginText}</Text>
                    </Box>
                    <Box style={styles.loginTextBox}>
                        <TextInput
                            style={styles.loginTextInput}
                            placeholder={Ajusts.Placeholder}
                            placeholderTextColor={Colors.lightGray}
                            secureTextEntry={false}
                            onChangeText={(userId) => setUserId(userId)}
                        />
                    </Box>
                </HStack>

                <TouchableOpacity disabled={loading} onPress={() => onPressLogin()} style={styles.loginButton}>
                    <LinearGradient
                        colors={
                            !loading
                                ? [Colors.primaryGradientStart, Colors.primaryGradientEnd]
                                : [Colors.lightGray, Colors.lightGray]
                        }
                        start={[0, 0]}
                        end={[1, 0]}
                        style={styles.loginButton}
                    >
                        {loading ? (
                            <Spinner color={Colors.primary} />
                        ) : (
                            <Text style={styles.loginButtonText}>ログインする</Text>
                        )}
                    </LinearGradient>
                </TouchableOpacity>
                {loginErrorMessage ? <Text style={styles.errorText}>{loginErrorMessage}</Text> : null}
                <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                    <Box style={styles.youtube}>
                        <video
                            width="200px"
                            controls
                            preload="none"
                            controlsList="nodownload"
                            poster={require('../assets/images/20260331_video_search.png')}
                            src={require('../assets/images/20260331_video_search.mp4')}
                        ></video>
                    </Box>
                    {/* <Box style={styles.youtube}>
                        <iframe
                            width="200px"
                            src="https://www.youtube-nocookie.com/embed/FjYVYaTY_mg?si=yYcuK9LkCestTyhB&rel=0"
                            title="コンテストサイト検索強化"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        ></iframe>
                    </Box> */}
                </View>
                {Ajusts.LoginTitle ? <Text style={styles.titleTxt}>{Ajusts.LoginTitle}</Text> : null}
                {Ajusts.LoginPeriod ? <Text style={styles.titlePeriod}>{Ajusts.LoginPeriod}</Text> : null}
            </View>
        </ScrollView>
    );
}
